import { CamposEditaveisDetalhamento } from './../../../../models/receber-divisao-honorarios.model';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DivisaoHonrariosDTO } from '@app/models/divisao-honorarios.model';
import { DetalharDivisaoHonorario, EdicaoDivisaoHonorarioInput, ReceberDivisaoHonorarios } from '@app/models/receber-divisao-honorarios.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Paginacao } from '@app/models/util/paginacao';
import { ConsultasService } from '@app/services/consultas.service';
import { DivisaoHonorariosService } from '@app/services/divisao-honorarios.service';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-divisao-honorarios-detalhar',
  templateUrl: './divisao-honorarios-detalhar.component.html'
})
export class DivisaoHonorariosDetalharComponent implements OnInit {

  lstDRReceber: IdDescricao[] = [];
  lstDRPagar: IdDescricao[] = [];

  editMode: boolean = false;

  divisao: DivisaoHonrariosDTO = new DivisaoHonrariosDTO();
  divisaoEdicao: EdicaoDivisaoHonorarioInput = new EdicaoDivisaoHonorarioInput();
  divisaoDetalhada: DetalharDivisaoHonorario = new DetalharDivisaoHonorario();
  paginacaoReceber: Paginacao = new Paginacao();

  editando: boolean = false;

  constructor(
    private divisaoServico: DivisaoHonorariosService,
    private routerParam: ActivatedRoute,
    private router: Router,
    @Inject(ToastrService) public toastr: ToastrService,
    private consultasService: ConsultasService) { }

  ngOnInit(): void {
    this.routerParam.params.subscribe(params => {
      const divisaoID = params['id'];
      this.divisaoServico.DetalharDivisaoHonorario(divisaoID).subscribe(
        data => {
          this.divisaoDetalhada = data;
          this.divisaoEdicao = data.CamposEditaveisDetalhamento;
          this.divisaoEdicao.VencimentoInicial = this.divisaoEdicao.VencimentoInicial.split('T')[0];
          const listaAdvogados = data.ListaAdvogados;
          this.divisaoEdicao.Advogados = listaAdvogados;
          this.divisaoEdicao.Advogados.forEach(
            advogado => 
            {
              advogado.AdvogadoId = listaAdvogados.find(x => x.Id === advogado.Id).Id;
              advogado.Percentual = listaAdvogados.find(x => x.Id === advogado.Id).ValorPercentual;
            }
          );
        },
        error => {
          this.toastr.warning("Realize a pesquisa novamente.");
        }
      );
    });

    this.consultasService.consultar('DR_R').subscribe(data => this.lstDRReceber = data);
    this.consultasService.consultar('DR_D').subscribe(data => this.lstDRPagar = data);

  }

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  onSubmit() {
    this.editando = true;
    this.divisaoServico.EditarDivisaoHonorarios(this.divisaoEdicao).subscribe(
      () => {
        this.toastr.success("Divisão editada com sucesso.");
        this.router.navigate(['financeiro/divisaoHonorarios']);
      },
      error => {
        this.toastr.warning(error.error.errors[0]);
        this.editando = false;
      }
    );
  }

  replaceCommaWithDot(value: string): number {
    return parseFloat(value.replace(',', '.'));
  }

  public receberPageChanged(event: any): void {
    // this.receberObterTodos(this.pesquisaReceber, event.page);
  }

}
